import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "../../api/axios";
import { useAuth } from "../../context/AuthProvider";
import { Helmet } from "react-helmet-async";
import './LoginSignup.css';

const ForgotPassword = () => {
  const { auth } = useAuth();
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [sending, setSending] = useState(false);
  const [cooldown, setCooldown] = useState(0);

  // Cooldown timer effect
  useEffect(() => {
    if (cooldown > 0) {
      const timer = setTimeout(() => setCooldown(cooldown - 1), 1000);
      return () => clearTimeout(timer);
    }
  }, [cooldown]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (sending || cooldown > 0) return;
    setMessage("");
    setError("");
    setSending(true);

    try {
      await axios.post("/api/auth/forgot-password", { email });
    } catch (err) {
      // Ignore backend errors for security
    } finally {
      // Show spinner for 1s, THEN show message and start cooldown
      setTimeout(() => {
        setSending(false);
        setMessage("If there is an account associated with this email, you will receive a password reset link.");
        setCooldown(30); // 30s cooldown
      }, 500);
    }
  };

  return (
    <>
      <Helmet>
      <title>Admin - Website Name</title>
      <meta name="robots" content="noindex, nofollow" />
    </Helmet>
    <div className="auth-page-wrapper">
      <div className="auth-container">
        <h2>Forgot Password</h2>
        <p>Remembered your password? <Link to="/login">Login</Link></p>

        {/* Show message only when not sending */}
        {message && !sending && (
          <p className="success" aria-live="polite" style={{marginTop: 12}}>{message}</p>
        )}
        {error && <p className="error" aria-live="polite">{error}</p>}

        <form onSubmit={handleSubmit} autoComplete="off">
          <label htmlFor="forgot-password-email" className="sr-only">Enter your email address</label>
          <input
            id="forgot-password-email"
            type="email"
            placeholder="Enter your email"
            autoComplete="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            disabled={sending || cooldown > 0}
            required
          />
          <button
            type="submit"
            disabled={sending || !email || cooldown > 0}
            aria-label="Send password reset link"
            className={sending || cooldown > 0 ? "btn-disabled" : ""}
          >
            {sending
              ? <div className="spinner"></div>
              : cooldown > 0
                ? `Try again in ${cooldown}s`
                : "Send Reset Link"}
          </button>
        </form>
      </div>
    </div>
    </>
  );
};

export default ForgotPassword;
